import { contactEmail, SiteFooter } from "./SiteFooter"

// Like the legal pages, this is a plain document with no API calls, so it
// renders the same signed in or signed out.
export function About() {
	return (
		<div class="h-100 overflow-auto">
			<div class="container page" style="max-width: 40rem;">
				<h1>About Quizfish</h1>

				<div class="stack gap-3">
					<p>
						Quizfish is a trivia game. Ten questions from one topic, played on
						your own or against a friend. I built this because I wanted to play
						something like this for myself and for my kids.
					</p>
					<p>
						It is deliberately small: a new round generated each time you play,
						no leaderboards or streaks. Twenty-three topics: fifteen general
						trivia and eight made for young children.
					</p>
					<p>
						Built and run by <a href="https://sharats.me">Shri</a> as a personal
						project, in Go and Preact.
					</p>
				</div>

				<div class="stack gap-3">
					<h2>Joining</h2>
					<p>
						Anyone can <a href="/signup">sign up</a>. You'll get an email with a
						link to verify your address — click it and you can play. Playing
						against someone means being friends with them first, so bring the
						people you want to play against, or tweet at{" "}
						<a href="https://x.com/sharat87">@sharat87</a>.
					</p>
				</div>

				<div class="stack gap-3">
					<h2>Contact</h2>
					<p>
						Found a question with a wrong answer, or have a topic you'd like to
						see? Email <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
					</p>
				</div>

				<SiteFooter />
			</div>
		</div>
	)
}
